import { SubmitHandler } from 'react-hook-form';
import { GetDigitalAssetShareMerchantEmployees, GetDigitalAssetShareMerchants, ShareDigitalAssetRequest } from '../../service/serviceService';
import { ShareContentPage } from './ShareContentPage';
import { useTypedSelector } from '../../hooks/TypedReduxHooks';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function DigitalAssetShare(): JSX.Element {
  const navigate = useNavigate();
  const [token, selectedAssets]: any = useTypedSelector((state) => [state.userReducer.token, state.digitalAssetReducer.selectedAssets]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit: SubmitHandler<any> = async (data) => {
    if (token) {
      setLoading(true);
      const merchantRecipientIds = data?.MerchantRecipientIds?.map((r: any) => r?.Recipients?.map((re: any) => re.Id)).flat();
      const portalRecipientIds = data?.PortalManagerRecipientIds?.map((r: any) => r.Id);

      ShareDigitalAssetRequest(
        token,
        {
          Body: data.body,
          Subject: data.subject,
          DigitalAssetIds: selectedAssets?.map((asset: any) => asset.DigitalAssetId) as string[],
          MerchantRecipientIds: merchantRecipientIds,
          PortalManagerRecipientIds: portalRecipientIds
        },
        () => {
          navigate(-1);
        },
        (error) => {
          setError(error.response?.data.Error || '');
          setLoading(false);
        }
      );
    }
  };

  return (
    <ShareContentPage
      title='Share Digital Asset'
      loading={loading}
      error={error}
      onSubmit={(data: ISharePageContent) => onSubmit(data)}
      getShareMerchants={GetDigitalAssetShareMerchants}
      getShareMerchantEmployees={GetDigitalAssetShareMerchantEmployees} />
  );
}
